import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { navigationRef } from '../utils/navigation'

export const NavigationSetter = () => {
  // Renaming to 'history' makes the code clearer
  const history = useHistory()

  useEffect(() => {
    // Set the history object on our reference
    navigationRef.navigate = history

    return () => {
      navigationRef.navigate = null
    }
  }, [history])

  return null
}
